/* eslint-disable no-undef */

/**
 * Manage submission and validation of QuestionForm
 */
import { post } from '../../../../helper/xhrAPI'

const createAlert = (type, message, parentClass, referenceElem) => {
  const alert = document.querySelector(`${parentClass} .notification`)
  alert.className = `notification is-light ${type === 200 ? 'is-success' : 'is-danger'}`
  alert.innerHTML = message
  document.querySelector(parentClass).insertBefore(alert, document.querySelector(referenceElem))
  if (type === 200) {
    document.querySelector(referenceElem).classList.add('is-hidden')
  }
}

const renderErrors = errors => {
  Object.keys(errors).forEach(error => {
    const errorHolder = document.querySelector(`.${error}-error`)
    errorHolder.innerHTML = errors[error].errors
  })
}

const QuestionMaker = () => {
  if (document.querySelector('#validateQuestion')) {
    document.querySelector('#validateQuestion').addEventListener('click', e => {
      e.preventDefault()
      e.target.classList.add('is-loading')
      grecaptcha.ready(function () {
        grecaptcha.execute(`${e.target.getAttribute('data-sitekey')}`, { action: 'submit' }).then(function (token) {
          const data = new FormData(document.getElementById('question-form'))
          data.append('g-recaptcha-response', token)
          const locale = document.querySelector('html').getAttribute('lang')
          post(`/${locale}/make-question`, data, response => {
            createAlert(response.code, response.message, '.question-form', '#question-form')
            if (response.code !== 200) {
              renderErrors(response.errors)
            }
            e.target.classList.remove('is-loading')
          })
        })
      })
    })
  }
}

export default QuestionMaker
